import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const UserPageFilter = ({ filter, setState }) => {
    const [statusFilter, setFilterStatus] = useState(filter);
    const { t: translate } = useTranslation();
    useEffect(() => {
        setState(statusFilter);
    }, [statusFilter]);
    return (_jsx(Box, { sx: { pb: .5 }, children: _jsx(Grid, { container: true, size: 12, sx: {
                gap: 5,
                justifyContent: "flex-end"
            }, children: _jsx(Grid, { size: {
                    xs: 8,
                    sm: 4,
                    md: 2
                }, children: _jsxs(FormControl, { variant: "outlined", fullWidth: true, children: [_jsx(InputLabel, { children: translate("SelectStatus") }), _jsxs(Select, { value: statusFilter, onChange: (e) => {
                                setFilterStatus(e.target.value);
                            }, label: translate("SelectStatus"), id: "status", children: [_jsx(MenuItem, { value: "Active", children: translate("Active") }), _jsx(MenuItem, { value: "Inactive", children: translate("InActive") }), _jsx(MenuItem, { value: "All", children: translate("All") })] })] }) }) }) }));
};
export default UserPageFilter;
